import React, { useState, useEffect, createRef, forwardRef } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import configureStore from "../store";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import Config from "config";
import { postApiDataAsync, kloader } from "../common/Common";
import { HeaderNav, MobileNav, HeaderWithSearch } from "../common/Header";
import { ClearCusInfo, formsCusInfoDataChange, addObjToCriteriaList } from "../stores/loginSlice";
import { LoginInputField, RequestOtpBtn, mtCustomerSubscribeToPayload } from "./Common";
import ReCAPTCHA from "react-google-recaptcha";

import { Login } from "./Login";
import { Register } from "./Register";
import { ProfileSetting } from "./ProfileSetting";

import "./Index.css";
const store = configureStore();

const ReCAPTCHASiteKey = Config.ReCAPTCHASiteKey;

// axios.defaults.headers.common['Authorization'] = store.getState().Token;
//process.env.API_ROOT_URL

const pagesLink = Config.pagesLink;
const $ = window.$;

const App = () => {
  const [Page, setPage] = useState(0);
  const [login, searchFilter, customerInfo] = useSelector((state) => [
    state.login,
    state.login.searchFilter,
    state.login.customerInfo,
  ]);
  const dispatch = useDispatch();

  const recaptchaRef = React.createRef();

  async function submit(callFrom) {
    if (!customerInfo.otpRef.value || !customerInfo.otpID.value) return;
    kloader();

    var objRequest = {};

    var urlPath = "/";

    if (callFrom == "Login") {
      urlPath = "/Login";
    } else if (callFrom == "Register") {
      urlPath = "/Register";
    }

    try {
      recaptchaRef.current?.reset();
      const token = await recaptchaRef.current.executeAsync();
      objRequest.recapchaResult = token;
    } catch (error) {}

    postApiDataAsync({
      urlPath: urlPath,
      objRequest: {
        request: {
          token: objRequest.recapchaResult,
          MailTO: customerInfo.email.value,
          VerifyOtpID: customerInfo.otpID.value,
          OTPReference: customerInfo.otpRef.value,
          OTPVerifyNo: customerInfo.otp.value,
          Fullname: customerInfo.fullName.value,
          Telno: customerInfo.phone.value,
        },
      },
    })
      .then((data) => {
        console.log("data", data);
        if (!data.TokenResponse.AccessToken) {
          throw "No Token";
        }

        dispatch(
          formsCusInfoDataChange({ field: "token", value: data.TokenResponse.AccessToken })
        );

        // init info
        dispatch(formsCusInfoDataChange({ field: "fullName", value: data.MtCustomer.FULLNAME }));
        dispatch(formsCusInfoDataChange({ field: "phone", value: data.MtCustomer.TELNO }));
        dispatch(formsCusInfoDataChange({ field: "IsActive", value: data.MtCustomer.IS_ACTIVE }));

        // init MtCustomerSubscribe
        if (data.MtCustomer.MT_CUSTOMER_SUBSCRIBEs && data.MtCustomer.MT_CUSTOMER_SUBSCRIBEs.length > 0) {
          data.MtCustomer.MT_CUSTOMER_SUBSCRIBEs.forEach((element) => {
            const payload = mtCustomerSubscribeToPayload(element);
            dispatch(addObjToCriteriaList(payload));
          });
        }

        setPage(2);
      })
      .catch(function (error) {
        console.log(error);
        switch (error.ErrorCode) {
          case "ACCOUNT_EXIST":
            setPage(0);
            showPop("อีเมลนี้เคยลงทะเบียนแล้ว");
            break;
          case "INVALID_CREDENTIAL":
            setPage(1);
            showPop("ไม่พบอีเมลในระบบ กรุณาลงทะเบียน");
            break;
          case "INVALID_OTP":
            showPop("รหัส OTP ไม่ถูกต้อง");
            break;
          default:
            showPop(error.ErrorMessage);
            break;
        }
      })
      .then(() => {
        kloader();
      });
  }

  return (
    <>
      {/* <button onClick={e => { setPage((Page + 1) % 3) }} >ClickMe</button>
        <button onClick={e => { showPop("test") }} >Popup</button> */}

      <ReCAPTCHA ref={recaptchaRef} size="invisible" sitekey={ReCAPTCHASiteKey} />

      {Page === 0 && <Login goToStep={setPage} showPop={showPop} submit={submit} />}
      {Page === 1 && <Register goToStep={setPage} showPop={showPop} submit={submit} />}
      {Page === 2 && <ProfileSetting goToStep={setPage} showPop={showPop} />}

      <div id="errorPopUp" className="mfp-hide white-popup icw errorLoginPopup">
        <div className="box-delete">
          <i className="ic-npa ic-npa-icon-alert"></i>
          <div id="errorMsg" className="title-delete">
            เกิดข้อผิดพลาด
          </div>
        </div>
        <div className="box-btn contentCenter">
          <button
            onClick={(e) => {
              e.preventDefault();
              $.magnificPopup.close();
            }}
            className="btn-green btn-confirm mousePointer mfp-close btnGreenWithmfp"
          >
            ยืนยัน
          </button>
        </div>
      </div>
    </>
  );
};

function showPop(message) {
  $("#errorMsg").html(message);
  const popup = $("#errorPopUp");
  if ($.magnificPopup) {
    $.magnificPopup.open({
      items: [
        {
          src: popup,
        },
      ],
      type: "inline",
      overflowY: "scroll",
      closeMarkup:
        '<button type="button" class="mfp-close"><i class="ic-npa ic-npa-icon-plus"></i></button>',
      autoFocusLast: false,
      fixedContentPos: true,
    });
  }
}

ReactDOM.render(
  <Provider store={store}>
    {/* <header id="header">
            <div id="header-bg" className="header-bg">
                <HeaderNav searchBtn={false} />
                <div id="inner-header-placeholder"></div>
            </div>
        </header>
        <MobileNav /> */}
    <HeaderWithSearch searchBtn={true} hideDesktop={true} />
    <div className="main-content">
      <App />
    </div>
  </Provider>,
  document.getElementById("react-app-login")
);

if (module.hot) {
  module.hot.accept();
}

console.log("react app login start");
